import { useMediaQuery } from "@material-ui/core";

export const useIsMobileView = () => {
  const mobileWidth = useMediaQuery("(max-width: 850px)", { noSsr: true });
  const mobileHeight = useMediaQuery("(max-height: 650px)", { noSsr: true });

  return mobileWidth || mobileHeight;
};
